/**
 * HttpService  对于Http的简单封装
 * 
 * bin.zhang
 */
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';

import { ToastController } from 'ionic-angular';
import { ToastAlert } from '../util/toastalert';
import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';
import { ThemeableBrowser, ThemeableBrowserOptions, ThemeableBrowserObject } from '@ionic-native/themeable-browser';
import { StorageService } from '../service/storageservice';
import { Utils } from '../service/utils';

@Injectable()
export class HttpService {

  constructor(public http: Http, public toastCtrl: ToastController, public toastAlert: ToastAlert,
    public inAppBrowser: InAppBrowser, private themeableBrowser: ThemeableBrowser) {
  }

  public get(url: string, paramObj: any): Promise<any> {
    return this.http.get(url + this.toQueryString(paramObj))
      .toPromise()
      .then(response => this.handleSuccess(response.json()))
      .catch(error => this.handleError(error));
  }

  public get2(url: string, paramObj: any): Promise<any> {
    return this.http.get(url + this.toQueryString(paramObj))
      .toPromise()
      .then(response => this.handleSuccess2(response.json()))
      .catch(error => this.handleError(error));
  }

  public post(url: string, paramObj: any): Promise<any> {
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post(url, this.toBodyString(paramObj), new RequestOptions({ headers: headers }))
      .toPromise()
      .then(response => this.handleSuccess(response.json()))
      .catch(error => this.handleError(error));
  }

  public post2(url: string, paramObj: any): Promise<any> {
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post(url, this.toBodyString(paramObj), new RequestOptions({ headers: headers }))
      .toPromise()
      .then(response => this.handleSuccess2(response.json()))
      .catch(error => this.handleError(error));
  }

  public postBody(url: string, paramObj: any): Promise<any> {
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post(url, paramObj, new RequestOptions({ headers: headers }))
      .toPromise()
      .then(response => this.handleSuccess(response.json()))//response => response.json()
      .catch(error => this.handleError(error));
  }

  private handleSuccess(response: any) {
    if (response.constructor == String) {//如果出现返回的json为string类型,手动将字符串转换为json格式
      response = JSON.parse(response);
    }
    if (response.code == '1000' || response.code == '200') {//请求数据成功
      //this.toastAlert.alertMsg(response.msg,'middle',1000);
      return response.obj;
    } else {//请求数据失败
      this.toastAlert.alertMsg(response.error, 'middle', 1000);
      //alert(response.error);//提示错误信息,弹窗后续修改
      return null;
    }
  }

  private handleSuccess2(response: any) {
    if (response.constructor == String) {//如果出现返回的json为string类型,手动将字符串转换为json格式
      response = JSON.parse(response);
    }
    return response;
  }

  private handleError(error: any) {
    let msg = '请求失败';
    if (error.status == 0) {
      msg = '请求地址错误或网络故障';
    }
    if (error.status == 400) {
      msg = '请求无效';
      console.log('请检查参数类型是否匹配');
    }
    if (error.status == 404) {
      msg = '请求资源不存在';
      console.error(msg + '，请检查路径是否正确');
    }
    if (error.status == 413) {
      msg = '上传文件太大';
      console.error(msg + '，上传文件太大');
    }
    if (error.status == 500) {
      msg = '请求内部出错';
      //针对微服务架构修改
      error = error.json();
      if( error.message != undefined && error.message != null && error.message != ''){
        msg = error.message;
      }
      console.error(msg + '，请检查程序是否正确');
    }
    this.toastAlert.alertMsg(msg, 'middle', 1000);
    return null;
  }

  /** 弹出框
   * msg  :弹出框显示信息
   * pst  :显示位置  top middle  bottom 
   * num  : 显示的时间长度  1000 = 1秒
   */
  alertMsg(msg: string, pst: string, num: number) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: num,
      position: pst
    });
    toast.present();
  }


  /**
   * @param obj　参数对象
   * @return {string}　参数字符串
   * @example
   *  声明: var obj= {'name':'小军',age:23};
   *  调用: toQueryString(obj);
   *  返回: "?name=%E5%B0%8F%E5%86%9B&age=23"
   */
  private toQueryString(obj) {
    let ret = [];
    for (let key in obj) {
      key = encodeURIComponent(key);
      let values = obj[key];
      if (values && values.constructor == Array) {//数组
        let queryValues = [];
        for (let i = 0, len = values.length, value; i < len; i++) {
          value = values[i];
          queryValues.push(this.toQueryPair(key, value));
        }
        ret = ret.concat(queryValues);
      } else { //字符串
        ret.push(this.toQueryPair(key, values));
      }
    }
    return '?' + ret.join('&');
  }

  /**
   *
   * @param obj
   * @return {string}
   *  声明: var obj= {'name':'小军',age:23};
   *  调用: toQueryString(obj);
   *  返回: "name=%E5%B0%8F%E5%86%9B&age=23"
   */
  public toBodyString(obj) {
    let ret = [];
    for (let key in obj) {
      key = encodeURIComponent(key);
      let values = obj[key];
      if (values && values.constructor == Array) {//数组
        let queryValues = [];
        for (let i = 0, len = values.length, value; i < len; i++) {
          value = values[i];
          queryValues.push(this.toQueryPair(key, value));
        }
        ret = ret.concat(queryValues);
      } else { //字符串
        ret.push(this.toQueryPair(key, values));
      }
    }
    return ret.join('&');
  }

  private toQueryPair(key, value) {
    if (typeof value == 'undefined') {
      return key;
    }
    return key + '=' + encodeURIComponent(value === null ? '' : String(value));
  }

  /**打开外部链接 */
  openOuterLink(title:any, url: any ,colorTheme:any) {
   
    let  options:InAppBrowserOptions  = {
      location : 'no',//Or 'no' 
      hidden : 'no', //Or  'yes'
      // clearcache : 'yes',
      // clearsessioncache : 'yes',
      zoom : 'yes',//Android only ,shows browser zoom controls 
      hardwareback : 'yes',
      mediaPlaybackRequiresUserAction : 'no',
      shouldPauseOnSuspend : 'no', //Android only 
      closebuttoncaption : 'Close', //iOS only
      disallowoverscroll : 'no', //iOS only 
      toolbar : 'no', //iOS only 
      enableViewportScale : 'no', //iOS only 
      allowInlineMediaPlayback : 'no',//iOS only 
      presentationstyle : 'pagesheet',//iOS only 
      fullscreen : 'yes',//Windows only    
    };

    let flag = "innerUser";
    let tempUrl = url;
    let index = url.indexOf(flag);
    if(index != -1){
      tempUrl = tempUrl + "&userId=";
      let user = StorageService.getObj('currentUser');
      if(user != null && user != undefined && user.xgh != null && user.xgh != undefined){
      //  tempUrl = tempUrl + user.xgh;//向十个服务传递学工号
      tempUrl = tempUrl + Utils.getRSAData(user.xgh);//向十个服务传递学工号
      }
    }
    //打包apk时使用
    // let target = "_blank";
    //打包wap版本实用 _self
    let target = "_self";
      let inAppBrowserRef = this.inAppBrowser.create(tempUrl,target, options);
      inAppBrowserRef.on('loadstart').subscribe(event => {
          if (event.url.match("/appportalwap")) {
          inAppBrowserRef.close();
        }
     });
  }

}


// WEBPACK FOOTER //
// ./src/providers/service/httpservice.ts